/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  FleetMember,
  FleetMembershipUpdateInput,
  SchemaValidationErrorResponse,
  StandardError,
  StandardMessage,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Leave Fleet
 */
export const leaveFleet = (
    fleetSlug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);

      return axiosClient<void>(
      {url: `/fleets/${fleetSlug}/membership`, method: 'DELETE', signal
    },
      );
    }




export const getLeaveFleetMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof leaveFleet>>, TError,{fleetSlug: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof leaveFleet>>, TError,{fleetSlug: string}, TContext> => {

const mutationKey = ['leaveFleet'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof leaveFleet>>, {fleetSlug: string}> = (props) => {
          const {fleetSlug} = props ?? {};

          return  leaveFleet(fleetSlug,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LeaveFleetMutationResult = NonNullable<Awaited<ReturnType<typeof leaveFleet>>>

    export type LeaveFleetMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Leave Fleet
 */
export const useLeaveFleet = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof leaveFleet>>, TError,{fleetSlug: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof leaveFleet>>,
        TError,
        {fleetSlug: string},
        TContext
      > => {
      return useMutation(getLeaveFleetMutationOptions(options), queryClient);
    }
    /**
 * @summary Fleet Membership Detail
 */
export const fleetMembership = (
    fleetSlug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);

      return axiosClient<FleetMember>(
      {url: `/fleets/${fleetSlug}/membership`, method: 'GET', signal
    },
      );
    }




export const getFleetMembershipQueryKey = (fleetSlug: MaybeRefOrGetter<string>,) => {
    return [
    'fleets',fleetSlug,'membership'
    ] as const;
    }


export const getFleetMembershipQueryOptions = <TData = Awaited<ReturnType<typeof fleetMembership>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetMembership>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetMembershipQueryKey(fleetSlug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetMembership>>> = ({ signal }) => fleetMembership(fleetSlug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetMembership>>, TError, TData>
}

export type FleetMembershipQueryResult = NonNullable<Awaited<ReturnType<typeof fleetMembership>>>
export type FleetMembershipQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Fleet Membership Detail
 */

export function useFleetMembership<TData = Awaited<ReturnType<typeof fleetMembership>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetMembership>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetMembershipQueryOptions(fleetSlug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Membership
 */
export const updateFleetMembership = (
    fleetSlug: MaybeRefOrGetter<string>,
    fleetMembershipUpdateInput: MaybeRefOrGetter<FleetMembershipUpdateInput>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
fleetMembershipUpdateInput = toValue(fleetMembershipUpdateInput);

      return axiosClient<FleetMember>(
      {url: `/fleets/${fleetSlug}/membership`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: fleetMembershipUpdateInput, signal
    },
      );
    }




export const getUpdateFleetMembershipMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFleetMembership>>, TError,{fleetSlug: string;data: FleetMembershipUpdateInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateFleetMembership>>, TError,{fleetSlug: string;data: FleetMembershipUpdateInput}, TContext> => {

const mutationKey = ['updateFleetMembership'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateFleetMembership>>, {fleetSlug: string;data: FleetMembershipUpdateInput}> = (props) => {
          const {fleetSlug,data} = props ?? {};

          return  updateFleetMembership(fleetSlug,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateFleetMembershipMutationResult = NonNullable<Awaited<ReturnType<typeof updateFleetMembership>>>
    export type UpdateFleetMembershipMutationBody = FleetMembershipUpdateInput
    export type UpdateFleetMembershipMutationError = ErrorType<ValidationError | StandardError>

    /**
 * @summary Update Membership
 */
export const useUpdateFleetMembership = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFleetMembership>>, TError,{fleetSlug: string;data: FleetMembershipUpdateInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateFleetMembership>>,
        TError,
        {fleetSlug: string;data: FleetMembershipUpdateInput},
        TContext
      > => {
      return useMutation(getUpdateFleetMembershipMutationOptions(options), queryClient);
    }
    /**
 * @summary Accept Membership
 */
export const acceptFleetMembership = (
    fleetSlug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);

      return axiosClient<StandardMessage>(
      {url: `/fleets/${fleetSlug}/membership/accept`, method: 'PUT', signal
    },
      );
    }




export const getAcceptFleetMembershipMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptFleetMembership>>, TError,{fleetSlug: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof acceptFleetMembership>>, TError,{fleetSlug: string}, TContext> => {

const mutationKey = ['acceptFleetMembership'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof acceptFleetMembership>>, {fleetSlug: string}> = (props) => {
          const {fleetSlug} = props ?? {};

          return  acceptFleetMembership(fleetSlug,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AcceptFleetMembershipMutationResult = NonNullable<Awaited<ReturnType<typeof acceptFleetMembership>>>

    export type AcceptFleetMembershipMutationError = ErrorType<ValidationError | StandardError>

    /**
 * @summary Accept Membership
 */
export const useAcceptFleetMembership = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptFleetMembership>>, TError,{fleetSlug: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof acceptFleetMembership>>,
        TError,
        {fleetSlug: string},
        TContext
      > => {
      return useMutation(getAcceptFleetMembershipMutationOptions(options), queryClient);
    }
    /**
 * @summary Decline Membership
 */
export const declineFleetMembership = (
    fleetSlug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);

      return axiosClient<StandardMessage>(
      {url: `/fleets/${fleetSlug}/membership/decline`, method: 'PUT', signal
    },
      );
    }




export const getDeclineFleetMembershipMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof declineFleetMembership>>, TError,{fleetSlug: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof declineFleetMembership>>, TError,{fleetSlug: string}, TContext> => {

const mutationKey = ['declineFleetMembership'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof declineFleetMembership>>, {fleetSlug: string}> = (props) => {
          const {fleetSlug} = props ?? {};

          return  declineFleetMembership(fleetSlug,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeclineFleetMembershipMutationResult = NonNullable<Awaited<ReturnType<typeof declineFleetMembership>>>

    export type DeclineFleetMembershipMutationError = ErrorType<ValidationError | StandardError>

    /**
 * @summary Decline Membership
 */
export const useDeclineFleetMembership = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof declineFleetMembership>>, TError,{fleetSlug: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof declineFleetMembership>>,
        TError,
        {fleetSlug: string},
        TContext
      > => {
      return useMutation(getDeclineFleetMembershipMutationOptions(options), queryClient);
    }
